import {Entity} from '@s-ui/domain'

export class LoanB2CEntity extends Entity {
  /**
   * @constructor
   * @param {String} id
   * @param {String} url
   */

  getLoanId() {
    return this._loanId
  }

  getLoanUrl() {
    return this._loanUrl
  }

  /**
   * @return {Object}
   */
  toJSON() {
    return {
      loanId: this.getLoanId(),
      loanUrl: this.getLoanUrl()
    }
  }
}
